function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.16 21.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10.58,21.16c5.84,0,10.58-4.74,10.58-10.58S16.42,0,10.58,0,0,4.74,0,10.58s4.74,10.58,10.58,10.58Z",
    style: {
      fill: "#001dd2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.03,14.76c.36,0,.65-.29.65-.65s-.29-.65-.65-.65-.65.29-.65.65.29.65.65.65Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4,11.31v-1.35s4.34-.1,4.85,4.81h-1.41s0-3.27-3.44-3.47Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.38,8.47v-1.28s7.03-.06,7.62,7.59h-1.38s.1-5.74-6.24-6.3Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.35,5.73v-1.31s9.61-.16,10.41,10.35h-1.38s.13-8.48-9.03-9.05h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/Connected.a650ceb34a52d8908939775cc90e2571.svg";
export { ForwardRef as ReactComponent };